module.exports = __webpack_public_path__ + "media/error.b6f91ae2.wav";